import { __awaiter } from "tslib";
import { CacheRepository } from '../utils/cache/cacheRepository';
// withPersistedCacheRequest - wraps a promise with persisted cache.
// the promise result will be cached in the session storage for the given ttlInSeconds
// it will be cleared once the session is aborted.
function withSessionCacheRequest(key, ttlInSeconds, promise) {
    return __awaiter(this, void 0, void 0, function* () {
        let result = CacheRepository.get(key);
        if (result) {
            return result;
        }
        try {
            result = yield promise();
            if (result !== null && result !== undefined) {
                CacheRepository.set(key, result, ttlInSeconds);
            }
            return result;
        }
        catch (err) {
            return null;
        }
    });
}
export default withSessionCacheRequest;
